module.exports = __webpack_public_path__ + "media/images/basics-ef07af1dc422372c2df3d689f02df904.svg";